/*
 * Public API Surface of angular-odata
 */

export * from './lib/index';
